import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HomeComponent } from './screens/home/home.component';
import { HeaderComponent } from './screens/header/header.component';
import { FooterComponent } from './screens/footer/footer.component';
import { AboutComponent } from './screens/home/about/about.component';
import { BulletinComponent } from './screens/home/bulletin/bulletin.component';
import { CounterComponent } from './screens/home/counter/counter.component';
import { HighlightComponent } from './screens/home/highlight/highlight.component';
import { MessageComponent } from './screens/home/message/message.component';
import { MissionComponent } from './screens/home/mission/mission.component';
import { NewsComponent } from './screens/home/news/news.component';
import { ShowcaseComponent } from './screens/home/showcase/showcase.component';
import { TourComponent } from './screens/home/tour/tour.component';
import { WhyComponent } from './screens/home/why/why.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { MapComponent } from './screens/footer/map/map.component';
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { environment } from '../environments/environment';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    AboutComponent,
    BulletinComponent,
    CounterComponent,
    HighlightComponent,
    MessageComponent,
    MissionComponent,
    NewsComponent,
    ShowcaseComponent,
    TourComponent,
    WhyComponent,
    MapComponent,

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    CarouselModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
